function matchesMediaQuery(breakpointName) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).matches;
}

class MegaMenuSections extends HTMLElement {
    constructor() {
      super();
      this.variantInfoContainers = Array.from(document.querySelectorAll(".mega-menu-section"));
      this.menuNav = Array.from(document.querySelectorAll(".attach-section"));
      if (Shopify.designMode) {
        this.variantInfoContainers.forEach((VariantInfo) => {
        VariantInfo.closest(".shopify-section").addEventListener("shopify:section:select", (event) => {
        this.innerHTML = VariantInfo.innerHTML;
        });
      });
      }
    }
    connectedCallback() {
    this.loadMegaMenuSections();  
    }
 loadMegaMenuSections() {
  this.variantInfoContainers.forEach((VariantInfo) => {
    this.menuNav.forEach((Nav) => {
      if (Nav.dataset.menu == VariantInfo.dataset.for && Nav.innerHTML.trim() === '') {
        Nav.innerHTML = VariantInfo.innerHTML;
      }
    });
  });     
  setTimeout(() => {
    customElements.whenDefined('x-tabs').then(() => {
        let component = document.querySelector('x-tabs');
        const template = document.createElement('template');
        template.innerHTML = `
            <slot role="tablist" part="tab-list" name="title"></slot> 
            <slot part="tab-panel-list" name="content"></slot>
        `;
        let newComponent = document.querySelector('x-tabs');
        if(newComponent){
        newComponent.reattachShadow(template);
        newComponent.connectedCallback();
        }
    });
}, 200);
  }
}
window.customElements.define("mega-menu-section", MegaMenuSections);
 
  class SubscribePicker extends HTMLElement {
    constructor() {
      super();
      this.optionSelectors = Array.from(this.querySelectorAll("[data-subscribe-selector]"));
      this.optionSelectorsVariants = Array.from(document.querySelectorAll(".subscription-variants"));
      this.subscribeInput = document.querySelector('input[name="selling_plan"]');
    }
    connectedCallback() {
      document.addEventListener('variant:change', e => {
        this.showSubscriptions(e);
      });
      this.optionSelectorsVariants.forEach((optionSelector) => {

        optionSelector.querySelector('input').addEventListener("change", this.loadSubscriptions.bind(this));
        if(optionSelector.querySelector('select')){
        optionSelector.querySelector('select').addEventListener("change", this.loadSubscriptionsDropdown.bind(this));
        }
      });
    }
    showSubscriptions(e) {
    let all_plans = this.querySelectorAll('input:not([value=""])');  
    let active_plans = e.detail.variant.selling_plan_allocations;
    all_plans.forEach(plan => {
      plan.parentElement.classList.add('hidden');
  });
    active_plans.forEach(plan =>{
    let activePlanInput = this.querySelector('input[value="' + plan.selling_plan_id +'"]').parentElement.classList.remove('hidden');
    if (activePlanInput) {
    }
    });
    }
    loadSubscriptions(e) {
      var currentSubscription = document.querySelector('.subscription-variants-selected div');
      currentSubscription.innerHTML = e.target.parentElement.innerHTML;
      if (e.target != null) {
        var subscribeId = e.target.getAttribute('data-subscription');
        if(subscribeId != ''){
        this.subscribeInput.value = subscribeId;
        this.changeSubscriptionUrl(subscribeId);
        }else{
        this.disableSubsription();
        }
      } else if(e != null){
        var subscribeId = e.getAttribute('data-subscription');
        if(subscribeId != ''){
        this.subscribeInput.value = subscribeId;
        this.changeSubscriptionUrl(subscribeId);
        }else{
        this.disableSubsription();
        }
      } else {
        this.disableSubsription();
      }
    }
    loadSubscriptionsDropdown(e) {
      var _this = this;
      if (e.target.value != '') {
        var subscribeId = e.target.value;
        e.target.closest('.subscription-variants').querySelector('input').checked = true;
        _this.subscribeInput.value = subscribeId;
        _this.changeSubscriptionUrl(subscribeId);
      } else {
        e.target.closest('.subscription-variants').querySelector('input').checked = false;
        disableSubsription();
      }
    }
    changeSubscriptionUrl(subscribeId) {
      if (history.pushState) {
        let searchParams = new URLSearchParams(window.location.search);
        if (subscribeId != undefined && subscribeId != '') {
          searchParams.set('selling_plan', subscribeId);
          let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
          window.history.pushState({
            path: newurl
          }, '', newurl);
        } else {
          let searchParams = new URLSearchParams(window.location.search);
          searchParams.delete('selling_plan');
          let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
          window.history.pushState({
            path: newurl
          }, '', newurl);
        }
      }
    }
    disableSubsription(){
    var _this = this;
    _this.subscribeInput.value = '';
    _this.changeSubscriptionUrl();
    }
  };
  
  window.customElements.define("subscribe-picker", SubscribePicker);

// js/common/overlay/modal.js 
import { Modal } from "theme";
import { animate as animate5 } from "vendor";
var ModalInline = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "false");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue); // Call the base class method

    if (name === 'open') {
      if(newValue === ''){
        animate5(this.closest('.ingredients'), {minHeight:[0, this.scrollHeight + 'px'] },{ duration: 0.2})
      }else{
        this.closest('.ingredients').style.minHeight = 'auto';
      }
    }
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "modal-inline-template";
  }
  get shouldLock() {
    return false;
  }
  get shouldAppendToBody() {
    return false;
  }
  get open() {
    return this.hasAttribute("open");
  }
  createEnterAnimationControls() {
  return animate5(this, { opacity: [0, 1] }, { duration: 0.2 });

  }
  createLeaveAnimationControls() {
  return animate5(this, { opacity: [1, 0] }, { duration: 0.2 }); 
  }
};
if (!window.customElements.get("inline-modal")) {
  window.customElements.define("inline-modal", ModalInline);
}


var CartLineItem = class extends HTMLElement {
  constructor(){
    super();
    this.boundChangeLineItem = this.changeLineItem.bind(this);
  }
  connectedCallback() {
    var options = this.querySelectorAll('.subscribe-swatch-radio');
    options.forEach((optionSelector) => {
      optionSelector.addEventListener("change", this.changeLineItem.bind(this));
  });
}
disconnectedCallback() {
  var options = this.querySelectorAll('.subscribe-swatch-radio');
  // Remove the listener using the same reference used to add it
  options.forEach((optionSelector) => {
    optionSelector.removeEventListener("change", this.boundChangeLineItem);
  });
}
changeLineItem(event){
// Log the line item attribute for debugging purposes
console.log(event.target.getAttribute('data-line'));

// Correctly format the 'remove' payload for the cart update
const lineItemKey = event.target.getAttribute('data-line');
const removePayload = { updates: { [lineItemKey]: 0 } };

// Define headers to be reused in both fetch calls
const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest'  // Necessary due to a Shopify bug
};

// Remove the item from the cart
fetch(`${Shopify.routes.root}cart/update.js`, {
  method: 'POST',
  credentials: 'same-origin',
  headers,
  body: JSON.stringify(removePayload),
}).then(function (response) {
  // Add the item back with new attributes
  const addItemPayload = {
    items: [{
      quantity: 1,
      id: lineItemKey,
      selling_plan: event.target.getAttribute('data-line-id'),
    }]
  };

  fetch(`${Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    credentials: 'same-origin',
    headers,
    body: JSON.stringify(addItemPayload),
  }).then(function (response) {
    response.json().then(function (cartContents) {
      // Trigger an event to indicate the operation has ended
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  });
});
}
}
if (!window.customElements.get("line-item")) {
  window.customElements.define("line-item", CartLineItem);
}


class VariantInformation extends HTMLElement {
  constructor() {
    super();
    this.variantInfoContainers = Array.from(document.querySelectorAll(".variant-information"));
    document.addEventListener('variant:change', e => {
      this.loadVariantInfo(e);
    });
    document.querySelectorAll("subscribe-picker input").forEach(subscribeVariant => {
      subscribeVariant.addEventListener('change', e => {
        this.loadVariantInfo(e);
      });  
    });
    document.querySelectorAll("#rc_container input").forEach(subscribeVariant => {
      subscribeVariant.addEventListener('change', e => {
        this.loadVariantInfo(e);
      });  
    });
    if (Shopify.designMode) {
      this.variantInfoContainers.forEach((VariantInfo) => {
      VariantInfo.closest(".shopify-section").addEventListener("shopify:section:select", (event) => {
      this.innerHTML = VariantInfo.innerHTML;
      });
    });
    }
  }
  connectedCallback() {
    var title = this.getAttribute('variant-title');
    this.loadCurrentVariantInfo(title);
  }
  loadVariantInfo(event) {
    this.variantInfoContainers.every((VariantInfo) => {
    if(event.detail != undefined){
    if(VariantInfo.getAttribute('for-variant') == event.detail.variant.title){
    this.innerHTML = VariantInfo.innerHTML;
    return false;  
    }else{
    this.innerHTML = '';
    return true;  
    }
    }else{
      if(VariantInfo.getAttribute('for-variant') == event.target.dataset.title){
        this.innerHTML = VariantInfo.innerHTML;
        return false;  
        }else{
        this.innerHTML = '';
        return true;  
        }
    }
    });
  }
  loadCurrentVariantInfo(title) {
    this.variantInfoContainers.every((VariantInfo) => {
    if(VariantInfo.getAttribute('for-variant') == title){
    this.innerHTML = VariantInfo.innerHTML;
    return false;  
    }else{
    this.innerHTML = '';
    return true;  
    }
    });
  }
};

window.customElements.define("variant-information", VariantInformation);


class TruncateTextComponent extends HTMLElement { 
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: 'open' });
    this._fullHTML = this.innerHTML.trim();
    this._maxHeightMobile = parseInt(this.getAttribute('max-height-mobile')) || 0;
    this._maxHeightDesktop = parseInt(this.getAttribute('max-height-desktop')) || 0;
    console.log('truncate component' + this);

    this._isOpen = false;
    this.createTruncate();
  }

  createTruncate() {
  
    const maxHeight = matchesMediaQuery("sm-max") ? this._maxHeightMobile : this._maxHeightDesktop;

    this._shadowRoot.innerHTML = `
      <style>
        .textContainer {
          overflow: hidden;
          max-height: ${this._isOpen ? 'none' : `${maxHeight}px`};
          transition: max-height 0.5s ease;
        }
        .toggleBtn {
          cursor: pointer;
          text-decoration: underline;
          display: block;
          margin-top: 10px;
        }
      </style>
      <div class="textContainer">${this._fullHTML}</div>
      <span class="toggleBtn">${this._isOpen ? 'Read Less' : 'Read More'}</span>
    `;

    this._textContainer = this._shadowRoot.querySelector('.textContainer');
    this._toggleBtn = this._shadowRoot.querySelector('.toggleBtn');

    this._toggleBtn.addEventListener('click', () => this.toggleContent());
  }

  toggleContent() {
    this._isOpen = !this._isOpen;
    const maxHeight = matchesMediaQuery("sm-max") ? this._maxHeightMobile : this._maxHeightDesktop;
    this._textContainer.style.maxHeight = this._isOpen ? 'none' : `${maxHeight}px`;
    this._toggleBtn.textContent = this._isOpen ? 'Read Less' : 'Read More';
  }
}

window.customElements.define('truncate-text-component', TruncateTextComponent); 

function injectMegaMenuContent() {
  const megaMenuSections = Array.from(document.querySelectorAll(".mega-menu-section"));
  const menuNavs = Array.from(document.querySelectorAll(".attach-section"));
  megaMenuSections.forEach((section) => {
    menuNavs.forEach((nav) => {
      if (nav.dataset.menu == section.dataset.for && nav.innerHTML.trim() === '') {
        nav.innerHTML = section.innerHTML;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', injectMegaMenuContent);
window.addEventListener('load', injectMegaMenuContent);

// /** Dynamic Multi-Variant Purchase & Cart Drawer Sync Handler


(function () {
  // 1. Calculate Option Prices (Dropdown text update)
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const symbol = window.Shopify?.currency?.active === 'GBP' ? '£' : '$';
    return `${symbol}${amount}`;
  }

  function recalculatePrices(container, variantPriceCents) {
    const select = container.querySelector('.custom-purchase-select');
    if (!select) return;

    Array.from(select.options).forEach((opt) => {
      if (opt.disabled) return;

      const discountType = opt.dataset.discountType;
      const discountValue = parseFloat(opt.dataset.discountValue || 0);
      const planName = opt.dataset.planName || 'One-time purchase';

      let finalPriceCents = variantPriceCents;

      if (discountType === 'percentage') {
        finalPriceCents = variantPriceCents - (variantPriceCents * (discountValue / 100));
      } else if (discountType === 'fixed_amount') {
        finalPriceCents = variantPriceCents - (discountValue * 100);
      }

      const formattedPrice = formatMoney(finalPriceCents);
      opt.textContent = `${planName} — ${formattedPrice}`;
      opt.dataset.calculatedPrice = formattedPrice;
    });
  }

  function initPurchaseOptionDropdowns() {
    const components = document.querySelectorAll(' .horizontal-product-card, cart-drawer, .cart-drawer, [is="cart-drawer"]');

    components.forEach((container) => {
      const select = container.querySelector('.custom-purchase-select');
      if (!select) return;

      const variantsData = JSON.parse(select.dataset.productVariants || '[]');
      const activeVariantInput = container.querySelector('select[name="id"], input[name="id"]') || document.querySelector('select[name="id"], input[name="id"]');
      
      let currentVariant = variantsData.find(v => v.id == activeVariantInput?.value) || variantsData[0];

      if (currentVariant) {
        recalculatePrices(container, currentVariant.price);
      }
    });
  }

  // 2. Before Form Submit: Sync Dropdown Value Safely with existing or new Selling Plan Input
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const container = form.closest('.horizontal-product-card, cart-drawer') || form;
    const select = container.querySelector('.custom-purchase-select');
    
    if (select) {
      let sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      
      // Only create input if App (Seal Subscriptions) hasn't already created one
      if (!sellingPlanInput) {
        sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        sellingPlanInput.className = 'custom-selling-plan-input';
        form.appendChild(sellingPlanInput);
      }

      sellingPlanInput.value = select.value || '';
    }
  }, true);

  // 3. Update Selected Price on Dropdown Change
  document.addEventListener('change', (e) => {
    if (e.target.classList.contains('custom-purchase-select')) {
      const select = e.target;
      const container = select.closest('.horizontal-product-card, cart-drawer');
      const planInput = container ? container.querySelector('input[name="selling_plan"]') : null;
      const priceDisplay = container ? container.querySelector('price-list sale-price, .price-list, .price, [data-price]') : null;

      const selectedOption = select.options[select.selectedIndex];

      if (planInput) {
        planInput.value = selectedOption.value || '';
      }

      if (priceDisplay && selectedOption.dataset.calculatedPrice) {
        const srOnly = priceDisplay.querySelector('.sr-only');
        if (srOnly) {
          priceDisplay.innerHTML = srOnly.outerHTML + selectedOption.dataset.calculatedPrice;
        } else {
          priceDisplay.textContent = selectedOption.dataset.calculatedPrice;
        }
      }
    }

    // Update prices when Variant changes
    if (e.target.name === 'id') {
      const selectedVariantId = e.target.value;

      document.querySelectorAll('.horizontal-product-card, cart-drawer').forEach((container) => {
        const select = container.querySelector('.custom-purchase-select');
        if (!select) return;

        const variantsData = JSON.parse(select.dataset.productVariants || '[]');
        const activeVariant = variantsData.find(v => v.id == selectedVariantId);

        if (activeVariant) {
          recalculatePrices(container, activeVariant.price);
        }
      });
    }
  });

  // Initial Load
  initPurchaseOptionDropdowns();

  document.addEventListener('DOMContentLoaded', () => { initPurchaseOptionDropdowns(); });

  document.addEventListener('shopify:section:load', initPurchaseOptionDropdowns);
  
  // Theme & App Live Update Events (Including LimeSpot Drawer)
  document.addEventListener('cart:change', () => setTimeout(initPurchaseOptionDropdowns, 100));
  document.addEventListener('cart:updated', () => setTimeout(initPurchaseOptionDropdowns, 100));
  document.addEventListener('cart:refresh', () => setTimeout(initPurchaseOptionDropdowns, 100));
  document.addEventListener('limespot:cartDrawerRender', () => setTimeout(initPurchaseOptionDropdowns, 100));
})();


document.addEventListener('DOMContentLoaded', function () {
  const stickyATC = document.querySelector('product-sticky-bar');
  const productSection =
    document.querySelector('.product-info') ||
    document.querySelector('.shopify-section');

  if (!stickyATC || !productSection) return;

  /*
   * ==========================================
   * 1. SHOW / HIDE STICKY BAR ON SCROLL
   * ==========================================
   */

  let ticking = false;

  function handleScroll() {
    const sectionTop = productSection.offsetTop;
    const sectionHeight = productSection.offsetHeight;
    const scrollPosition = window.scrollY;

    if (scrollPosition > sectionTop + sectionHeight * 0.25) {
      stickyATC.classList.add('active');
    } else {
      stickyATC.classList.remove('active');
    }

    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    },
    { passive: true }
  );


  /*
   * ==========================================
   * 2. SMOOTH SCROLL TO PRODUCT OPTIONS
   * ==========================================
   */

  let isScrolling = false;
  let scrollAnimation = null;

  function scrollToOptions() {

    // Prevent multiple clicks / multiple animations
    if (isScrolling) return;

    const targetElement = document.querySelector(
      '[data-block-type="price"]'
    );

    if (!targetElement) return;

    /*
     * Find header height
     */
    const header =
      document.querySelector('.section-header') ||
      document.querySelector('height-observer');

    const headerHeight = header
      ? header.getBoundingClientRect().height
      : 0;

    /*
     * Calculate scroll positions
     */
    const startPosition = window.scrollY;

    const targetPosition =
      targetElement.getBoundingClientRect().top +
      window.scrollY -
      headerHeight -
      20;

    const distance = targetPosition - startPosition;

    /*
     * Different speed for mobile / desktop
     */
    const isMobile = window.innerWidth <= 768;

    const duration = isMobile ? 1200 : 800;

    let startTime = null;

    isScrolling = true;

    /*
     * Custom smooth scroll animation
     */
    function animateScroll(currentTime) {

      if (!startTime) {
        startTime = currentTime;
      }

      const elapsed = currentTime - startTime;

      const progress = Math.min(
        elapsed / duration,
        1
      );

      /*
       * Ease-in-out
       */
      const ease =
        progress < 0.5
          ? 2 * progress * progress
          : 1 -
            Math.pow(
              -2 * progress + 2,
              2
            ) / 2;

      window.scrollTo(
        0,
        startPosition + distance * ease
      );

      /*
       * Continue animation
       */
      if (progress < 1) {

        scrollAnimation =
          window.requestAnimationFrame(
            animateScroll
          );

      } else {

        /*
         * Animation finished
         */
        isScrolling = false;
        scrollAnimation = null;
      }
    }

    /*
     * Start immediately
     */
    scrollAnimation =
      window.requestAnimationFrame(
        animateScroll
      );
  }

  document.addEventListener('click', function (event) {

    const shopNowBtn =
      event.target.closest('#sticky-shop-now');

    if (!shopNowBtn) return;
    event.preventDefault();
    event.stopPropagation();
    scrollToOptions();

  });

});